import { render, staticRenderFns } from "./TradieRow.vue?vue&type=template&id=6c178aba&scoped=true"
import script from "./TradieRow.vue?vue&type=script&lang=js"
export * from "./TradieRow.vue?vue&type=script&lang=js"
import style0 from "./TradieRow.vue?vue&type=style&index=0&id=6c178aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c178aba",
  null
  
)

export default component.exports